import request from '@/utlis/request'

// 获取问题分类
export function getTroubleListApi () {
  return request({
    url: '/troubleType',
    method: 'get'
  })
}

// 获取问题所属协会
// export function getSSXHListApi () {
//   return request({
//     url: '/SSXH',
//     method: 'get'
//   })
// }

// 表单校验 --- 匿名访问接口
export function getNiMingApi (data) {
  return request({
    url: '/claim/registration/addComplaints',
    method: 'post',
    data
  })
}

// 获取问题所属协会 --- 部门查询
export function getAssociationApi () {
  return request({
    url: '/claim/registration/list',
    method: 'get'
  })
}
// 获取问题发生地 --- 省份查询
export function getProvinceApi (regionLevel) {
  return request({
    url: '/claim/registration/selectAddress',
    method: 'get',
    params: { regionLevel }
  })
}

// 获取问题发生地 --- 市、区查询
export function getShiQuApi (regionParentId) {
  return request({
    url: '/claim/registration/getAddrByParentId',
    method: 'get',
    params: { regionParentId }
  })
}
